import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/* eslint-disable react/prop-types */

/**
 * Simple static breadcrumb
 * @param path
 * @returns {XML}
 */
const Breadcrumb = ({ path = 'Root', inline = false }) => {
  let parts = path.split(',');

  let component = inline ? 'span' : 'div';

  return React.createElement(
    component,
    {},
    parts.map((s, i) => (
      <span>
        {s}&nbsp;{i === parts.length - 1 ? null : <Icon name="angle-right" />}
        &nbsp;
      </span>
    )),
  );
};

export default Breadcrumb;
